'use strict';

import {getUrlParam, userPrevent} from "../../functions";
import {projectMode, settingsData} from "../../settings";
import {PagesForPagination} from "../../common";
import {menuHandler} from "../menu/menu";
import {createModal} from "../cards/urlParamModal";
import {openOptionsCard} from "../cards/optionsCards";
import {isDesktopMode} from "../language/langSwitcher";

export class Pagination {
    static #prevent = false;

    constructor() {
        this.#addOnPopStateListener();
    }

    paginate(args) {
        if (window.history.state?.path || window.history.state?.page === undefined && args.source !== 'widgetsInit')
            return;
        switch (args.source) {
            case 'widget-close-button':
                window.history.back();
                break;
            case 'viewModesSwitching':
            case 'logoHandler':
                Pagination.#winHistPushState('3dModel');
                break;
            case 'flatCloseButtonHandler':
            case 'cardsBackButton':
                switch (settingsData.activeViewMode) {
                    case 'orbit':
                        Pagination.#winHistPushState('3dModel');
                        break;
                    case 'cylinder':
                        Pagination.#winHistPushState('search');
                        break;
                    default:
                        Pagination.#winHistPushState('search');
                        break;
                }
                break;
            case 'urlModalCloseButton':
            case 'searchBackNavButton':
            case 'appModal':
                Pagination.#winHistPushState('3dModel');
                break;
            case 'widgetsInit':
                if (getUrlParam('prop')) {
                    args.flatId = getUrlParam('prop');
                    Pagination.#winHistPushStateProp(args);
                    return;
                } else if (Object.values(PagesForPagination).includes(getUrlParam('p'))) {
                    Pagination.#winHistPushState(getUrlParam('p'));
                    menuHandler({target:{dataset:{menuItem:getUrlParam('p')}}}, config.general);
                    return;
                }

                if ((!getUrlParam('p') || !Object.values(PagesForPagination).includes(getUrlParam('p'))) && !getUrlParam('prop')) {
                    if (isDesktopMode()) {
                        window.history.pushState({page: '3dModel'}, document.title, `/?p=3dModel&desktop=1`);
                    } else {
                        window.history.pushState({page: '3dModel'}, document.title, `/?p=3dModel`);
                    }
                    return;
                }

                if (Object.values(PagesForPagination).includes(getUrlParam('p')))
                    menuHandler({target:{dataset:{menuItem:getUrlParam('p')}}}, config.general);

                break;
            case 'menuHandler':
                const menuItem = args.menuItem;
                if (menuItem === 'getApp' || menuItem === 'contactUs') {
                    switch (settingsData.activeViewMode) {
                        case 'cylinder':
                            Pagination.#winHistPushState('search');
                            break;
                        case 'orbit':
                            Pagination.#winHistPushState('3dModel');
                            break;
                    }
                    break;
                }
                if (Object.values(PagesForPagination).includes(menuItem))
                    Pagination.#winHistPushState(menuItem);
                break;
            case 'openOptionsCard':
                Pagination.#winHistPushStateProp(args);
                break;
            default:
                console.log('paginationHandler: default case');
                break;
        }
    }

    #addOnPopStateListener() {
        window.onpopstate = (e) => {
            if (userPrevent() ||
                !settingsData.slideShowed ||
                !settingsData.flyIsComplete ||
                projectMode.Pagination.prevent) {
                //window.history.forward();
                e.preventDefault();
                return;
            }

            if (!window.history.state) location.reload();

            Pagination.#removeActiveGalleryItem();

            if (Object.values(PagesForPagination).includes(getUrlParam('p')))
                menuHandler({target: {dataset: {menuItem: getUrlParam('p')}}}, config.general);
            if (getUrlParam('prop') && window.history.state?.source === 'widgetsInit') {
                createModal();
            } else if (getUrlParam('prop')) {
                openOptionsCard();
            }
        };
    }

    static set prevent(value) {
        Pagination.#prevent = value;
    }

    static get prevent() {
        return Pagination.#prevent;
    }

    static #winHistPushState(page) {
        if (window.history.state?.page === page)
            return;
        if (isDesktopMode()) {
            window.history.pushState({page: page}, document.title, `/?p=${page}&desktop=1`);
        } else {
            window.history.pushState({page: page}, document.title, `/?p=${page}`);
        }
    }

    static #winHistPushStateProp(args) {
        if (window.history.state?.UID === parseInt(getUrlParam('prop')) ||
            window.history.state?.page === 'flat' && getUrlParam('prop'))
            return;
        if (isDesktopMode()) {
            window.history.pushState(
                {page: 'flat', UID: args.flatId, source: args.source},
                document.title,
                `/?desktop=1&prop=${args.flatId}`
            );
        } else {
            window.history.pushState(
                {page: 'flat', UID: args.flatId, source: args.source},
                document.title,
                `/?prop=${args.flatId}`
            );
        }
    }

    static #removeActiveGalleryItem() {
        const galleryOpenedItem = document.getElementsByClassName('fancybox__main-container show-fancybox-gallery')[0];
        if (!galleryOpenedItem) return;

        const fancyboxWrapper = galleryOpenedItem.getElementsByClassName('fancybox__wrapper')[0];

        galleryOpenedItem.classList.remove('show-fancybox-gallery');
        document.body.classList.remove('fancybox-active');
        fancyboxWrapper.innerHTML = '';
    }
}